/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ username: NonNullable<unknown>, temporaryPassword: NonNullable<unknown> }} Cognito_Invitation_Sms_MessageInputs */

const en_cognito_invitation_sms_message = /** @type {(inputs: Cognito_Invitation_Sms_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recobra: username ${i?.username}, temporary password ${i?.temporaryPassword}.`)
};

const pt_br2_cognito_invitation_sms_message = /** @type {(inputs: Cognito_Invitation_Sms_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recobra: usuário ${i?.username}, senha temporária ${i?.temporaryPassword}.`)
};

/**
* | output |
* | --- |
* | "Recobra: username {username}, temporary password {temporaryPassword}." |
*
* @param {Cognito_Invitation_Sms_MessageInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_sms_message = /** @type {((inputs: Cognito_Invitation_Sms_MessageInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_Sms_MessageInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_sms_message(inputs)
	return pt_br2_cognito_invitation_sms_message(inputs)
});